import 'moment/locale/ru.js';
import { ITranslationForMts } from './translationInterface';

export const ruRuForMts: ITranslationForMts = {
    route_PrematchHome: 'lv',
    route_TopBetsMobile: 'top',
    route_HomeTopBetsDesktop: 'most-popular',
    route_HomeLiveDesktop: 'live',
    route_HomeHotBetsDesktop: 'hotbets',
    route_HomeTicketOfDayDesktop: 'bet-of-the-day',
    route_HomeTopOfferDesktop: 'top-offer',
    route_SportsList: 'sports',
    route_StandardEvents: 'events',
    route_StandardEventDetail: 'event',
    route_LiveEvents: 'live-events',
    route_LiveEventDetail: 'live-event',
    route_CashOut: 'cashout',
    route_BetDetail: 'my-betslip',
    route_BetDetailPublic: 'betslip',
    route_LegacyTicketDetailPublic: "betslipl",
    route_BetList: 'my-betslips',
    route_BetListVG: 'my-betslips-vg',
    route_BetWinList: 'my-wins',
    route_Search: 'search',
    route_MarketingAction: 'competitions',
    route_TicketDetail: 'my-betslip',
    route_TicketDetailVG: 'my-betslip-vg',
    route_TicketDetailByNumber: 'find-betslip',
    route_Calendar: 'calendar',
    route_Favorites: 'favorites',
    route_Top5Bets: '',
    route_Top10Bets: '',
    //
    no_categories: 'Нет категорий',
    today: 'Сегодня',
    tomorrow: 'Завтра',
    yesterday: 'Вчера',
    weekend: 'Конец недели',
    todayTomorrow: 'Сегодня, Завтра',
    by_date: 'По дате',
    by_time: 'По времени',
    by_week_day: 'По дням недели',
    hour: 'час',
    three_hours: '3 часа',
    hours: 'часы',
    more: 'Больше',
    available_tips: 'Прогнозы',
    date: 'Дата',
    game: 'Игра',
    deposit: 'Депозит:',
    eventual_winnings: 'Потенциальный выигрыш',
    detail: 'Подробнее',
    other: 'Другие',
    less: 'Меньше',
    all: 'Всё',
    result: 'Результат',
    statistics: 'Статистика',
    search: 'Поиск …',
    no_results: 'Нет результатов',
    detail_not_found: 'Подробности не найдены',
    back: 'Назад',
    next: "Далее",
    final_rate: 'Финальный коэффициент:',
    finished: 'Закончен',
    match: 'Матч',
    bet: 'Ставка',
    rate: 'Коэффициент',
    ticket_code: 'Код купона',
    state: 'Статус',
    date_paid: 'Дата оплаты',
    stake: 'Ставка',
    eventual_win: 'Потенциальный выигрыш',
    ticket_type: 'Тип купона',
    bet_type: 'Тип ставки',
    channel: 'Источник',
    ticket_detail: 'Подробности купона',
    prize_paid: 'Финальный выигрыш',
    win_paid: 'Будет выплачено',
    ticket_public_link: 'Ссылка на купон:',
    refresh: 'Обновить',
    download_file: 'Загрузить файл',
    combination: 'комбинация',
    combinations_0: 'комбинации',
    combinations_few: 'комбинации',
    combinations_more: 'комбинации',
    combination_short: 'комб.',
    event_no_longer_available: 'Событие больше недоступно.',
    has_to_be_logged_in: 'Выполните вход для выбора категории.',
    something_went_wrong: 'Что-то пошло не так.',
    no_events_for_filter: "В фильтре нет доступных событий.",
    no_events_or_leagues_found: "В фильтре нет доступных событий или лиг.",
    search_searchEventTitle: "Поиск",
    flag_new: "new",

    // --------------------- general
    general_BtnMore: "Больше",
    general_Loading: 'Загрузка...',
    general_OddsDraw: "Ничья",
    general_EventGameGroupOther: "Другое",
    general_EventLiveTag: "LIVE",
    general_CriticalRenderError: 'Ошибка.',
    general_CriticalRenderRefreshBtn: 'Продолжить',
    general_CriticalRenderHomeBtn: 'Главная страница',
    general_ProgressContentError: 'Ошибка загрузки, пожалуйста, повторите попытку.',
    general_ErrorInInitialization: 'Ошибка инициализации',
    general_SessionExpired: 'Время сессии истекло',

    // ---------------------- menu
    menu_Top: "ТОП",
    menu_Prematch: "ПРЕМАТЧ",
    menu_Live: "LIVE",
    menu_Cashout: "CASHOUT",
    menu_Search: "Поиск",
    menu_Time: 'Время',

    // --------------------- live-menu
    liveMenu_overview: "Обзор событий",
    liveMenu_favourites: "Фавориты",
    liveMenu_event: "Одно событие",
    liveMenu_calendar: "Календарь событий",

    //------------------- topBets
    topbets_TopBetsTitle: "Популярные",
    topbets_HotBetsTitle: "Повышенные коэффициенты",
    topbets_NoResults: "Список пуст",
    topbets_Top5Title: "TOP 5",
    topbets_Top10Title: "TOP 10",

    //  ---------------------- prematch
    prematch_NoEventsForFilter: "В фильтре нет доступных событий.",
    prematch_SportListTitle: "КАТЕГОРИИ",
    prematch_SportListNoSport: "В выбранном интервале нет событий.",
    prematch_TimeFilterAll: "Все",
    prematch_TimeFilterToday: "Сегодня",
    prematch_TimeFilterTodayTomorrow: "Сегодня, Завтра",
    prematch_TimeFilterWeek: "Неделя",
    prematch_TabOdds: "Коэффициенты",
    prematch_TabStats: "Статистика",
    prematch_EventNotExists: "Событие больше недоступно.",
    prematch_EventListSectionTop: "ТОП",
    prematch_EventListSectionOthers: "Другие",
    prematch_MobileExpandMoreVMT: "+ Больше",
    prematch_MobileCollapseMoreVMT: "- Меньше",
    prematch_EventAvailableAsLive: "Матч начался, перейди на LIVE.",

    // --------------------- live offer
    live_noRates: "На данный момент коэффициенты недоступны.",
    live_seeOddsInDetail: "Нажмите здесь, чтобы открыть предложение ставок",
    live_EventHasEnded: "Событие закончилось.",
    live_OtherEventsBtn: "Другие события",
    live_TabOdds: "Коэффициенты",
    live_TabMatchTracker: "Match Tracker",
    live_TabMatchTrackerStats: "Статистика",
    live_TabVideo: "Видео",
    live_NoEvents: "Нет активных событий.",
    live_BaseballCurrentHalfInningStat: "Статистика текущего пол-иннинга",
    live_AmFootballAttackTeamStat: "Статистика атакующей команды",
    live_TimelineTitle: "ТАЙМЛАЙН МАТЧА",
    live_TimelineDesktopTitle: "События в матче",
    live_ScoreMainScoreTitle: "Результат",
    live_OddBelowName: "Под",
    live_Favorites: "Фавориты",
    live_NoFavorites: "Фавориты не выбраны.",

    live_WarrantyInfo: "Данное время и статистика имеет только информационный характер. SIA Joker Ltd бренд SynotTip не гарантирует точность и актуальность показанной информации (например, текущий результат). Данная информация не может являться основой для любой возможной жалобы.",

    // ------------------------------ desktop live
    desktopLive_OpenEvents: "Текущие события",
    desktopLive_FavoriteEvents: "Фавориты",
    desktopLive_NoFavoriteEvents: "Фавориты не выбраны. Вы можете выбрать событие, нажав на звёздочку слева от события",

    //--------------------- coupon
    coupon_commonError: "Купон содержит ошибочные прогнозы.",

    coupon_LoginForSend: "Выполните вход, чтобы сделать ставку",
    coupon_UpdatingSystem: "Обновление ...",
    coupon_CouponGeneralError: "Ошибка",
    coupon_CouponExpectedNotSystemError: "Ошибка системы, удалите прогноз и попробуйте еще раз",
    coupon_CopyGeneralError: "Ошибка купона",
    coupon_StakeInputError: "Сумма ставки не годна",
    coupon_TicketListCombination: "КОМБИНАЦИЯ",
    coupon_TicketListStake: "СТАВКА",
    coupon_TicketListRate: "КОЭФФИЦИЕНТ",
    coupon_TicketListPotentialWin: "ПОТЕНЦИАЛЬНЫЙ ВЫИГРЫШ",
    coupon_SystemSwitchLabel: "СИСТЕМА",

    coupon_HeaderSystemCouponSetting: "Настройки системной ставки",
    coupon_StakeTypeCoupon: "КУПОН",
    coupon_StakeTypeSystem: "СИСТЕМА",

    coupon_SummaryPricePotential: "Потенциальный выигрыш",
    coupon_Stake: "Ставка",
    coupon_MaxStake: "Макс. ставка",
    coupon_TotalRate: "Финальный коэффициент",
    coupon_StakeForOneTicketInSystem: "Ставка на одно событие в системе",
    coupon_AverageRate: "Средний коэф.",

    coupon_SentSuccessMessage: "Ваша ставка была сделана. Спасибо.",
    coupon_SentRejectMessage: "Ваша ставка отклонена",
    coupon_CopyTicket: "Копировать купон",
    coupon_NewTicket: "Новый купон",

    coupon_evaluateBtn: "Пересчитать",
    coupon_acceptRateChangeBtn: "Принять",
    coupon_sendToPay: "Подтвердить",

    coupon_liveAcceptHigerRate: "Принять более высокий коэффициент",
    coupon_liveAcceptAllRates: "Принять любой коэффициент",
    coupon_liveHint_Question: "Рекомендуемая сумма ставки {value}. Вы согласны?",
    coupon_liveHint_Yes: "Да",
    coupon_liveHint_No: "Нет",

    coupon_TypePrematch: "Прематч",
    coupon_TypeLive: "Live",

    coupon_OddTitle: "Ставка",

    coupon_AddPublicLinkToChat: "", //not used

    // -------------------- ticket
    ticket_TicketTabLabel: "Купон",
    ticket_BettingTicket: "Купон",
    ticket_SelectionCount: "Число прогнозов",
    ticket_StakeTypeAll: "КУПОН",
    ticket_StakeTypeUnit: "КОМБИ",
    ticket_StakeTypeTotal: "СИСТЕМА",
    ticket_OddTitle: "Ставка",
    ticket_BankerTitle: "Банкир",
    ticket_HasErrors: "Купон содержит ошибки",
    ticket_TicketTypeSimple: "Простой", //--Simple
    ticket_TicketTypeSystem: "Система",  //--System
    ticket_TicketTypeVGSplit: "-",
    ticket_TicketTypeVGCombi: "-",
    ticket_EvalTypeLost: "Проигрыш",
    ticket_EvalTypeWin: "Выигрыш",
    ticket_EvalTypeCancelledWithMP: "Отменен",
    ticket_EvalTypeCancelled: "Отменен",
    ticket_EvalTypeCashout: "Cashout",
    ticket_NoTips: "В Вашем купоне нет прогнозов.",
    ticket_Ticket: 'Купон',
    ticket_TicketStateSettled: "Оценен",
    ticket_TicketStateStorno: "Отмена",
    ticket_TicketStateStornoBySystem: "Купон отклонён",
    ticket_TicketStateStornoByMts: "Отмена",
    ticket_TicketStateCommonAccepting: "Обработка данных",
    ticket_TicketStateCommonAccepted: "Принято",
    ticket_Login: "Выполните вход, чтобы видеть купон.",
    ticket_Calculations: "Список комбинаций",
    ticket_NotFound: "Купон не найден",
    ticket_TicketOfNumberNotFound: "Купон {number} не найден",
    ticket_Group: "Группа",
    ticket_CashoutTab: "Cashout",
    ticket_PrepareTicket: "Подготовить",
    ticket_SelectionResult: "Результат",

    ticket_ReuseOddsTicketBtn: "Добавить в новый купон",
    ticket_ReuseOddsGeneralError: "Не удалось добавить прогнозы, повторите попытку еще раз.",
    ticket_ReuseOddsNotAllAddedError: "Некоторые прогнозы нельзя добавить в купон, так как они больше не активны.",

    //my-tickets
    myTickets_NoTicket: 'Нет купонов',
    myTickets_Login: "Выполните вход, чтобы увидеть купоны.",
    myTickets_ColumnPotentialPrice: 'Пот.в',
    myTickets_TypeSports: "SB",
    myTickets_TypeVirtualGames: "VG",

    //Mobile App advert
    mobileAppAdvert_title: "Мобильное приложение для тотализатора",

    // ---------------------- bet detail
    bet_TicketIdTitle: "ID купона",
    bet_TicketStateTitle: "Статус",
    bet_TicketReasonTitle: "Причина",
    bet_TicketDatePaid: "Дата оплаты",
    bet_System: "Система",
    bet_Stake: "Ставка",
    bet_TotalRate: "Финальный коэффициент",
    bet_PotentialPrice: "Потенциальный выигрыш",
    bet_FinalWin: "Финальный выигрыш",
    bet_ToPayout: "Будет выплачено",
    bet_TicketType: "Тип купона",
    bet_BetType: "Тип ставки",
    bet_CanBeCancelledUntil: "Купон возможно отменить до:",
    bet_Channel: "Источник",
    bet_Match: "Матч",
    bet_Tip: "Прогноз",
    bet_TipWinTip: "Прогноз / Выигр. прогноз",
    bet_TipTicketDetail: "Прогноз",
    bet_Sum: "Сумма", // kde sa používa?
    bet_PossibleWinFrom: "Пот. выигрыш от",
    bet_PossibleWinTo: "Пот. выигрыш до",
    bet_Errors: 'Ошибки',
    bet_HandlingFee: "Комиссия",
    bet_ProductFee: "Комиссия",// kde sa používa?
    bet_ProductName: "Продукт",
    bet_OddsRateAdvantage: "Advanced rate",
    bet_RateAdvantageFactor: "Rate advantage",
    bet_Header: "Подробности купона",
    bet_SuccessfulCashout: "Cashout запрошен успешно",
    bet_ErrorDuringCashout: "Невозможно запросить Cashout",
    bet_ReallyCashoutBetOfValue: "Вы действительно хотите сделать Cashout {value} ?",
    bet_PublicLink: "Ссылка на купон",
    bet_TransferToCredit: "Перечислить на баланс",
    bet_TransferToBank: "Перечислить в банк",
    bet_FreeTicketSection: "Free ticket",

    bet_CopyConfirmYes: "Да",
    bet_CopyConfirmNo: "Нет",
    bet_CopyConfirmQuestion: "Чтобы сделать ставку на меньшую сумму, необходимо переписать купон. Вы согласны?",
    bet_CopyConfirmTitle: "КУПОН",

    bet_AgreeWithLowerAmount: "Вы согласны с меньшей суммой?",
    bet_Cashout: "Cashout",
    bet_ErrorInTicketListLoad: "Ошибка загрузки списка купонов",

    bet_CancelUntil: 'Cancel possible until:',
    bet_CancelSuccess: 'Ticket has been cancelled.',
    bet_CancelError_AlreadyCancelled: 'Ticket has been already cancelled',
    bet_CancelError_PeriodOver: 'Time limit for cancellation has passed.',
    bet_CancelError_NotForThisPlayer: 'Ticket is for another player.',
    bet_CancelError_GeneralError: 'Cancellation error',
    bet_CancelBetBtnCancelTitle: "Cancel",

    coupon_CashoutAcceptHigerRate: "Accept higher amount",
    coupon_CashoutAcceptAllRates: "Accept any amount",
    coupon_cashoutButton: "Cashout for {value}",


    // ---------------- cashoutList
    cashoutList_ColumnTime: "время",
    cashoutList_ColumnStake: "ставка",
    cashoutList_ColumnPotentialPrice: "Выигрыш",
    cashoutList_ColumnSell: "Cashout",
    cashoutList_NoTickets: "Нет доступных для Cashout купонов.",
    cashoutList_Login: "Выполните вход, чтобы увидеть купоны для Cashout.",
    cashoutList_LoadAgain: "Перезагрузить",

    //--------------------- betList
    betList_TicketNumber: 'Номер купона',
    betList_ColumnTime: "Дата",
    betList_ColumnStake: "Ставка",
    betList_ColumnPotentialPrice: "Пот.в",
    betList_ColumnPricePotentialPrice: "Пот.в/выигрыш",
    betList_ColumnStatus: "Статус",
    betList_ColumnDetail: "Подробности",

    //--------------------- ticketList
    ticketList_TimeFilter_None: "всё",
    ticketList_TimeFilter_Day: "День",
    ticketList_TimeFilter_ThreeDays: "Три дня",
    ticketList_TimeFilter_Week: "Неделя",
    ticketList_TimeFilter_TwoWeeks: "2 недели",
    ticketList_TimeFilter_Month: "Месяц",

    ticketList_StateFilter_None: "всё",
    ticketList_StateFilter_Accepted: "Принято",
    ticketList_StateFilter_Win: "Выигрыш",
    ticketList_StateFilter_Loss: "Проигрыш",
    ticketList_StateFilter_CancelWithHandlingFee: "Отмена",
    ticketList_StateFilter_Cashout: "Сделан cashout",
    ticketList_StateFilter_Storno: "Отмена",

    ticketList_OfferTypeFilter_None: "всё",
    ticketList_OfferTypeFilter_Prematch: "Пре-матч",
    ticketList_OfferTypeFilter_Live: "Live",

    ticketList_Title: "Список купонов",
    ticketList_TimeFilterTitle: "Интервал времени",
    ticketList_StateFilterTitle: "Статус",
    ticketList_OfferTypeFilterTitle: "Тип ставки",
    ticketList_FilterSubmit: "Показать",

    // ------------- ticket detail
    bet_FinalScoreInfo: "Финальный результат отображается включая штрафное и доп. время.",

    //-------------------- search
    search_FillSomethingInfo: "Введите событие или лигу.",
    search_LastSearch: "Последний поиск:",
    search_ResultEvents: "События",
    search_ResultLeagues: "Лиги",
    search_NothingFound: "Событие или лига не найдены.",
    search_InProgress: "Поиск ...",

    // ----------------- offline
    offline_InfoText: "Подключение к серверу или сети прервано",
    offline_TryReconnect: "Попробуйте подключиться снова",

    // ------------ recommended
    recommended_title: "Рекомендуемые",

    // ----------- mobile QR code
    mobileAppLinkAdvert_Header: "Mobile application",

    // ----------- marketing action
    marketingAction_NoAction: "Акции не найдены",
    marketingAction_Next: "Далее",
    marketingAction_Less: "Меньше",

    //--------- live stream / matchtracker
    liveStream_Opening: "Загрузка ...",
    liveStream_ErrorOpening: "Ошибка загрузки видео.",
    liveStream_NeedToLogin: "Выполните вход, чтобы смотреть Прямую трансляцию.",
    liveStream_NeedLiveStreamAccess: "Пожалуйста, завершите регистрацию, чтобы смотреть прямую трансляцию.",
    liveStream_NotPlayedNow: "Прямая трансляция недоступна.  Начало трансляции %1.",
    liveStream_NotAvailableFormat: "Невозможно загрузить видео. Начало трансляции %1.",
    liveStream_TryAgain: "Попробуйте еще раз",
    liveStream_NoVideoForThisPart: "Невозможно загрузить видео.",
    livestream_Login: "Login",

    // -------- live notifications
    liveNotification_ErrorOnUpdate: "Ошибка обновления",
    liveNotification_Header: "Live оповещения",
    liveNotification_AllowRequestText: 'Включите уведомления в настройках вашего устройства',
    liveNotification_AllowRequestButton: 'Разрешить',
    liveNotification_NeedAllowInBrowserPermissions: "Вы должны включить уведомления через свой браузер в разделе «Настройки сайта».",

    //right column
    rightColumn_MyBetsToday: "МОИ СТАВКИ СЕГОДНЯ",
    rightColumn_NoBetsToday: "У вас нет ставок сегодня",
    rightColumn_LoadAgain: "Перезагрузить",

    //find ticket by number
    findTicketByNumber_title: "Проверить купон",
    findTicketByNumber_InfoText: "Пожалуйста, введите номер купона:",
    findTicketByNumber_buttonSend: "Проверить",
    findTicketByNumber_Placeholder: "Номер купона",

    //chat
    chat_WriteMessagePlaceholder: "your message...",  //chat.yourMessage
    chat_SendMessage: "Send", //chat.sendMessage
    chat_Sending: "Sending ...", //chat.sendingText
    chat_LoginToSendMessage: "Log in to send message...",  //chat.loginToSendMessageInfo
    chat_LoadingMessages: "loading messages ...",
    chat_ErrorLoadingMessagesAgainBtn: "again",  //chat.btnErrorLoadingMessagesAgain
    chat_ErrorLoadingMessage: "unable to load the mesages",  //chat.errorLoadingMessages
    chat_PrivateReply: "Private reply",//chat.privateReply     // cjuba "Uživatelé mi můžou psát privátně",  //chat.acceptAllUsers
    chat_PublicReply: "Public reply",  //chat.publicReply
    chat_AcceptAllUsers: "Accept all users",  //chat.acceptAllUsers
    chat_BlockAllUsers: "Block all users",  //chat.blockAllUsers
    chat_BlockedUser: "Blocked user", //chat.blockedUser
    chat_NonblockedUser: "User not blocked",
    chat_NeedNickname: "Your nickname is not entered. Chat will be available to you after choosing a Nickname in your account settings",
    chat_AnswerForTitle: "Answer for",
    chat_ChatSendMessage_Success: "Message was sent",  //chat.sendMsgOk
    chat_ChatSendMessage_NonExistentReply: "Message on which you are replying is not available",  //chat.sendMsgNoSourceMsg
    chat_ChatSendMessage_PrivateBlocked: "User has blocked private messages",  //chat.sendMsgBlockedPrivate
    chat_ChatSendMessage_TimeConstraintFailed: "You need to wait %1 seconds before sending another message", //chat.sendMsgProtection
    chat_ChatSendMessage_UserBanned: "User is banned",  //chat.sendMsgBanned
    chat_ChatSendMessage_UserNotLogged: "You are not logged in",  //chat.sendMsgNotLogged
    chat_ChatSendMessage_Fail: "Unable to send message",  //chat.sendMsgError

    //saved ticket  // netreba prekladat do SK a CZ, pouziva sa iba v LV
    savedTicket_header: 'Внимание',
    savedTicket_thanks: 'Ваш номер купона сохранен. Спасибо.',
    savedTicket_p1: 'Вы можете сделать ставку в любом пункте приёма ставок, используя номер купона',
    savedTicket_p2: 'Ставка может быть сделана только до начала события.',
    savedTicket_warning: 'Используйте номер по возможности быстрее, так как коэффициенты могут измениться.',
    savedTicket_identicalBet: 'Идентичная ставка',

    //calendar
    calendar_startTime: 'время начала',
    calendar_event: 'события',
    calendar_category: 'категории',

    //upcoming events
    upcomingEvents_label: 'скоро',

    //favorites
    my_favorites: "Фавориты",

    //live Favorites
    liveFavorites_showMoreDetails: "Показать больше",
    liveFavorites_hideMoreDetails: 'Показывай меньше',

    //OTB
    otb_Switch: 'Быстрая ставка',
    otb_InfoText: 'Выбери быструю ставку, чтобы делать ставки в один клик!',
    otb_InfoWarning: "Подтверди настройки Быстрой ставки.",
    otb_SettingHeader: "Настройки Быстрой ставки:",
    otb_FirstPage_Cancel: "Отмена",
    otb_FirstPage_Confirm: "Подтвердить",
    otb_TurnOffOTB: "Откл. Быструю ставку",
    otb_CancelBetslip: "Отмена купона",
    otb_Sending: "подтверждаю",

    // rate filter
    rateFilter_Title: "Коэффициент",
    rateFilter_From: "От",
    rateFilter_To: "К"
};

